// Vuex connections module actions

import { API } from '@/config';

import {
  FILL_LIST, UPDATE_LIST_BY_CALLBACK_STEP,
} from './mutations-types';

export default {

  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('/callback/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },


  async checkIfAnyoneIsCallingBack({ commit }, connectionUuid) {
    try {
      const params = {
        connection: connectionUuid,
      };
      const { records } = (await API.get('/callback/checkIfAnyoneIsCalling', { params })).data.data;

      const result = {
        isCalling: records === 'calling',
        connectionUuid,
        statusName: 'CALLING',
      };

      commit(UPDATE_LIST_BY_CALLBACK_STEP, result);
      return result;
    } catch (err) {
      console.log(err);
      return '';
    }
  },

};
